(function ($) {$(function(){
    updateGridItemHeight();
});}(_jQ3));

window.addEventListener('resize', updateGridItemHeight);

function updateGridItemHeight(){
    var $boxContainer = _jQ3('.contact-header .box-container');
    if ($boxContainer.length) {
        var width = $boxContainer.find('.box').first().width();
        var height = $boxContainer.find('.box').first().height();
        $boxContainer.css('--box-width', width + 'px');
        $boxContainer.css('--box-height', height + 'px');
    }
}
